export const RECEIVE_ACCOUNT_EXPERIENCE = 'RECEIVE_ACCOUNT_EXPERIENCE'
export const RECEIVE_ACCOUNT_EXPERIENCE_ERROR = 'RECEIVE_ACCOUNT_EXPERIENCE_ERROR'